import useMediaQuery from 'helpers/hooks/useMediaQuery';
import React, { useState } from 'react';
import { desktop, tablet, mobile, xxs, ultraTablet } from 'helpers/utils/screensizes';
import {
  CustomFitPopUpData,
  MainHeadingBlock,
  PopUpHeading,
  RadioButtonContent,
  RadioButtonMainHeadingBlock,
  SubContentBlock,
  SubContentItem,
} from 'shared/types/product/Product';

type popupDataProps = {
  popupData: CustomFitPopUpData;
  setSelectedOption: (title: string) => void;
  selectedOption: string | null;
};
const PopUp = ({ popupData, setSelectedOption, selectedOption }: popupDataProps) => {
  const [isDesktopSize] = useMediaQuery(ultraTablet);
  const [isTablet] = useMediaQuery(tablet);
  const [ismobile] = useMediaQuery(xxs);
  const mainHeading = popupData?.mainHeading?.find((heading: MainHeadingBlock) =>
    isDesktopSize
      ? heading.layout === 'desktop'
      : ismobile
      ? heading?.layout === 'mobile'
      : heading?.layout === 'desktop',
  );
  const subHeading = popupData?.subContents?.find((subContent: SubContentBlock) =>
    isDesktopSize
      ? subContent.layout === 'desktop'
      : ismobile
      ? subContent?.layout === 'mobile'
      : subContent?.layout === 'desktop',
  );
  const radioButtonMainHeadingBlocks = popupData?.radioButtonMainHeadingBlocks?.find(
    (radioButtonText: RadioButtonMainHeadingBlock) =>
      isDesktopSize
        ? radioButtonText?.layout === 'desktop'
        : ismobile
        ? radioButtonText?.layout === 'mobile'
        : radioButtonText?.layout === 'desktop',
  );
  return (
    <div
      className={`absolute left-1/2 top-1/2 z-40 inline-flex
               min-w-[354px] -translate-x-1/2 items-center rounded-lg border md:min-w-[740px] lg:min-w-[989px]`}
      style={{ boxShadow: '10px 10px 16px 0px rgba(0, 0, 0, 0.16)', backgroundColor: popupData?.backgroundColour }}
    >
      <div className={`grid grid-cols-1 justify-center ${isDesktopSize ? 'md:grid-cols-2' : ''}`}>
        <div className="left-content h-[100%] w-[100%]">
          <img
            src={popupData?.imageForDesktop}
            className="h-full w-full rounded-tl-lg rounded-tr-lg border-b border-l border-t object-cover md:rounded-bl-lg md:rounded-tr-none"
          />
        </div>
        <div className="right-content flex flex-col">
          <div className="space-y-15 p-24">
            {mainHeading?.headings?.map((i: PopUpHeading, idx: number) => {
              return (
                <p key={idx} style={{ whiteSpace: 'pre-line' }}>
                  {i?.text?.split(',').map((part, index) => (
                    <span
                      key={index}
                      style={{
                        fontSize: `${i?.fontSizeForHeading}px`,
                        color: i?.colour,
                        fontWeight: 900,
                      }}
                    >
                      {part.trim()}
                      {index !== i.text.split(',').length - 1 && ','}
                      {index !== i.text.split(',').length - 1 && <br />}
                    </span>
                  ))}
                </p>
              );
            })}
            <hr />
            <div className="flex flex-col gap-y-10 space-y-5">
              {subHeading?.items?.map((i: SubContentItem, idx: number) => {
                return (
                  <div key={idx}>
                    <p
                      style={{ fontSize: `${i?.fontSizeForHeading}px`, color: i?.headingColour, fontWeight: 900 }}
                      className="mb-5"
                    >
                      {i?.heading}
                    </p>
                    <p
                      key={idx}
                      style={{ fontSize: `${i?.fontSizeForParagraph}px`, color: i?.paragraphColour, fontWeight: 400 }}
                    >
                      {i?.paragraph}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="p-24">
            <p
              className="mb-15"
              style={{
                fontSize: `${radioButtonMainHeadingBlocks?.fontSizeForRadioButtonMainHeading}px`,
                color: radioButtonMainHeadingBlocks?.radioButtonMainHeadingTextColour,
                fontWeight: 900,
              }}
            >
              {radioButtonMainHeadingBlocks?.radioButtonMainheading}
            </p>

            {radioButtonMainHeadingBlocks?.radioButtonContent?.map((item: RadioButtonContent, index: number) => {
              return (
                <div key={index} className="mb-15 flex items-start">
                  <label className="mr-4 inline-flex cursor-pointer items-center">
                    <input
                      type="radio"
                      name="customFitting"
                      value={item?.title}
                      checked={selectedOption === item?.title}
                      onChange={() => setSelectedOption(item?.title)}
                      className="hidden"
                    />
                    <div className="flex items-center">
                      <span
                        className={`relative mr-7 flex h-16 w-16 items-center justify-center rounded-full border border-black ${
                          selectedOption === item?.title ? 'bg-white' : ''
                        }`}
                      >
                        {selectedOption === item?.title && (
                          <span className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-black"></span>
                        )}
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: `${item?.fontSizeForTitle}px`,
                        color: item?.titleTextColour,
                      }}
                    >
                      {item?.title}
                    </span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
